import notification from 'antd/es/notification';

export default class Message {
  static success(arg) {
    notification.success({
      title: arg,
      description: '',
      placement: 'bottomLeft',
    });
  }

  static warning(arg) {
    notification.warning({
      title: arg,
      description: '',
      placement: 'bottomLeft',
    });
  }

  static error(arg) {
    notification.error({
      title: arg,
      description: '',
      placement: 'bottomLeft',
    });
  }
}
